import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../lib/api';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        await authAPI.googleSession(sessionId);
        await checkAuth();
        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (e) {
        console.error('Google auth failed:', e);
        navigate('/login');
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-[#FADB5F] mx-auto mb-4" />
        <p className="text-sm text-[#94A3B8]">Signing in with Google...</p>
      </div>
    </div>
  );
}
